var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star-text"},[(_vm.saleStar > 0 || _vm.avgStar > 0)?_c('div',{staticClass:"star-cell"},[_c('i',{staticClass:"el-icon-star-on star-icon"}),_c('span',[_vm._v(_vm._s(_vm.saleStar + '+' + _vm.avgStar))])]):_c('div',{staticClass:"no-star"},[_vm._v("暂无星级")])])
}
var staticRenderFns = []

export { render, staticRenderFns }